import { InjectionToken } from "@angular/core";

import { NewsItem } from "../schemas/news-item";

export interface NewsRepositoryPort {
  getNewsItemsForLanguage(language: string): Promise<NewsItem[]>;
}

export const NEWS_REPOSITORY = new InjectionToken<NewsRepositoryPort>("NewsRepositoryPort");
